"use strict";

const INVOICE_AMOUNT_DECLARATION = "Arrêtée la présente facture à la somme de :";
const units = ["zéro", "un", "deux", "trois", "quatre", "cinq", "six", "sept", "huit", "neuf", "dix", "onze", "douze", "treize", "quatorze", "quinze", "seize"];

function belowHundred(value, followedByNumber = false) {
  if (value < 17) return units[value];
  if (value < 20) return "dix-" + units[value - 10];
  if (value >= 80) {
    const remainder = value - 80;
    return remainder ? "quatre-vingt-" + belowHundred(remainder) : "quatre-vingt" + (followedByNumber ? "" : "s");
  }
  const tens = Math.min(6, Math.floor(value / 10));
  const remainder = value - tens * 10;
  const prefix = ["", "", "vingt", "trente", "quarante", "cinquante", "soixante"][tens];
  if (!remainder) return prefix;
  return prefix + (remainder === 1 || remainder === 11 ? " et " : "-") + belowHundred(remainder);
}

function belowThousand(value, followedByNumber = false) {
  if (value < 100) return belowHundred(value, followedByNumber);
  const hundreds = Math.floor(value / 100);
  const remainder = value % 100;
  const prefix = (hundreds === 1 ? "" : units[hundreds] + " ") + "cent";
  if (!remainder) return prefix + (hundreds > 1 && !followedByNumber ? "s" : "");
  return prefix + " " + belowHundred(remainder, followedByNumber);
}

function integerInWords(value) {
  if (value === 0) return units[0];
  const groups = [
    [1000000000000000, "billiard"],
    [1000000000000, "billion"], [1000000000, "milliard"], [1000000, "million"],
    [1000, "mille"], [1, ""],
  ];
  const parts = [];
  for (const [scale, name] of groups) {
    const count = Math.floor(value / scale);
    value %= scale;
    if (!count) continue;
    if (scale === 1) parts.push(belowThousand(count));
    else if (scale === 1000) parts.push((count === 1 ? "" : belowThousand(count, true) + " ") + name);
    else parts.push(belowThousand(count) + " " + name + (count > 1 ? "s" : ""));
  }
  return parts.join(" ");
}

const currencies = {
  XOF: ["franc CFA", "francs CFA"], XAF: ["franc CFA", "francs CFA"],
  CFA: ["franc CFA", "francs CFA"], FCFA: ["franc CFA", "francs CFA"],
  EUR: ["euro", "euros"], USD: ["dollar américain", "dollars américains"],
  CAD: ["dollar canadien", "dollars canadiens"], GBP: ["livre sterling", "livres sterling"],
  CHF: ["franc suisse", "francs suisses"], GNF: ["franc guinéen", "francs guinéens"],
  CDF: ["franc congolais", "francs congolais"], MAD: ["dirham marocain", "dirhams marocains"],
  DZD: ["dinar algérien", "dinars algériens"], TND: ["dinar tunisien", "dinars tunisiens"],
  MRU: ["ouguiya", "ouguiyas"], MGA: ["ariary", "ariarys"],
};

/** Convertit le TTC affiché, sans arrondir ni recalculer le montant enregistré. */
function invoiceAmountInWords(amount, currency = "XOF") {
  if (amount === null || amount === undefined || amount === "") return "";
  let normalized = String(amount).trim().replace(/\s/g, "").replace(",", ".");
  if (/e/i.test(normalized) && Number.isFinite(Number(normalized))) {
    normalized = Number(normalized).toLocaleString("en-US", { useGrouping: false, maximumFractionDigits: 20 });
  }
  if (!/^-?\d+(?:\.\d+)?$/.test(normalized)) return "";
  const negative = normalized.startsWith("-");
  const [whole, fraction = ""] = normalized.replace(/^-/, "").split(".");
  const integer = Number(whole);
  const decimals = fraction.replace(/0+$/, "");
  if (!Number.isSafeInteger(integer) || (decimals && !Number.isSafeInteger(Number(decimals)))) return "";
  const code = String(currency || "XOF").trim().toUpperCase();
  let words = integerInWords(integer);
  if (code === "GBP" || code === "MRU") words = words.replace(/\bun$/, "une");
  if (decimals) {
    const leadingZeros = decimals.match(/^0*/)[0].length;
    words += " virgule " + "zéro ".repeat(leadingZeros) + integerInWords(Number(decimals));
  }
  // Une devise inconnue conserve son code plutôt qu'un nom de monnaie inventé.
  const names = currencies[code] || [code, code];
  const currencyName = names[integer < 2 ? 0 : 1];
  const connector = !decimals && integer >= 1000000 && integer % 1000000 === 0 ? " de " : " ";
  words = (negative && (integer || decimals) ? "moins " : "") + words + connector + currencyName;
  return words.charAt(0).toUpperCase() + words.slice(1) + ".";
}

module.exports = { INVOICE_AMOUNT_DECLARATION, invoiceAmountInWords };
